import { render, staticRenderFns } from "./broker.vue?vue&type=template&id=5ae91896"
import script from "./broker.vue?vue&type=script&lang=js"
export * from "./broker.vue?vue&type=script&lang=js"
import style0 from "./broker.vue?vue&type=style&index=0&id=5ae91896&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports